export default __webpack_public_path__ + "static/CorprateHp-slider-e8fcaeba3e840e8a7bedc87b9bc12e39.gif";